export default function addEventListener(target, eventType, callback) {
    if (target) {
        if (typeof target.addEventListener === 'function') {
            target.addEventListener(eventType, callback, false);
            return {
                remove: function () {
                    target.removeEventListener(eventType, callback, false);
                },
            };
            // @ts-ignore
        }
        if (typeof target.attachEvent === 'function') {
            // @ts-ignore
            target.attachEvent('on' + eventType, callback);
            return {
                remove: function () {
                    // @ts-ignore
                    target.detachEvent('on' + eventType, callback);
                },
            };
        }
    }
}
//# sourceMappingURL=add-event-listener.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_dom-util@2.0.2@@antv/dom-util/esm/add-event-listener.js
// module id = null
// module chunks = 